<script setup>
import {useMatchedBetStore} from "@/stores/MatchedBetStore";
import {ref, computed} from 'vue';
import {useOddsmatcherStore} from "@/stores/OddsmatcherStore";
import OddsmatcherPleaseLogIn from "@/components/oddsmatcher/OddsmatcherPleaseLogIn.vue";

const matchedBetStore = useMatchedBetStore();
const oddsmatcherStore = useOddsmatcherStore();

const currentIndex = ref(0);

const matchedBets = computed(() => {
  const all_bookie_matched_bets =  oddsmatcherStore.getFilteredMatchedBets({selectedBookies: matchedBetStore.oddsmatcherData.bookie});
  return all_bookie_matched_bets.reduce((acc, currentBet) => {
    const backData = {...matchedBetStore.backBetData, odds: currentBet.backBet.odds}
    const layData = {...matchedBetStore.layBetData, odds: currentBet.layBet.odds}
    const results = matchedBetStore.getResults(backData, layData)
    acc.push({...currentBet, ...results});
    return acc;
}, []).sort((a, b) => b.profit - a.profit);
});

const nMatchedBets = computed(() => {
  return Object.keys(matchedBets.value).length
})


const nextSlide = () => {
  if (currentIndex.value < matchedBets.value.length - 1) {
    currentIndex.value++;
  }
};

const prevSlide = () => {
  if (currentIndex.value > 0) {
    currentIndex.value--;
  }
};

const trackStyle = computed(() => ({
  transform: `translateX(-${currentIndex.value * 100}%)`,
}));

const isPrevDisabled = computed(() => currentIndex.value === 0);
const isNextDisabled = computed(() => currentIndex.value === matchedBets.value.length - 1);


const formatDate = (dateString) => {
  const options = {year: 'numeric', month: 'long', day: 'numeric', hour: '2-digit', minute: '2-digit', hour12: false};
  const date = new Date(dateString);
  return new Intl.DateTimeFormat('en-UK', options).format(date);
};

function formatPound(value) {
  const formattedValue = Number(value).toFixed(2);
  return formattedValue < 0 ? `-£${Math.abs(Number(formattedValue)).toFixed(2)}` : `£${formattedValue}`;
}

const profitClass = (profit) => {
  return profit < 0 ? 'negative-profit' : 'positive-profit';
};

</script>


<template>
  <div class="oddsmatcher-carousel" v-if="matchedBetStore.backBetData.stake && matchedBetStore.oddsmatcherData.bookie">
    <button @click="prevSlide" :disabled="isPrevDisabled"
            class="oddsmatcher-carousel-control oddsmatcher-carousel-prev">❮
    </button>
    <div class="oddsmatcher-carousel-container">
      <div class="oddsmatcher-carousel-track" :style="trackStyle">
        <div class="oddsmatcher-carousel-slide" v-for="(bet, key) in matchedBets" :key="key">
          <div class="oddsmatcher-matched-bet-container">
            <template v-if="oddsmatcherStore.userAuthorization === 1 && key % 2 === 0 && nMatchedBets > 1">
              <OddsmatcherPleaseLogIn/>
            </template>
            <template v-else>
              <div class="om-choice-head">
                <h6 class="heading-small" :class="profitClass(bet.profit)">
                  Profit: {{ formatPound(bet.profit) }}
                </h6>
                <button @click="oddsmatcherStore.handleSelectMatchedBet(bet)" class="button button-small">Select Bet</button>
              </div>

              <div class="om-event">
                <h6>Event: {{ bet.eventDescription }}</h6>
                <p>Kickoff: {{ formatDate(bet.eventStart) }}</p>
                <p>Selection: {{ bet.selection }}</p>
              </div>

              <div class="om-back">
                <h6>Back bet </h6>

                <p>Bookie: {{ bet.backBet.bookieDisplay }}</p>
                <p>Stake: {{ formatPound(bet.backStake) }}</p>
                <p>Odds (decimal): {{ parseFloat(parseFloat(bet.backBet.odds).toFixed(4)).toString() }}</p>
              </div>
              <div class="om-lay">
                <h6>Lay bet </h6>
                <p>Exchange: ({{ bet.layBet.bookieDisplay }})</p>
                <p>Stake: {{ formatPound(bet.layStake) }}</p>
                <p>Odds (decimal): {{ bet.layBet.odds }}</p>

                <p>Liability: {{ formatPound(bet.layLoss) }}</p>
              </div>
            </template>

            <!--            <span v-if="oddsmatcherStore.userLoggedIn">
                                        Showing all {{ lengthAllMatchedBets }} results
                        </span>
                        <span v-else>
                          Showing {{ Object.keys(shownMatchedBets).length }} out of {{ lengthAllMatchedBets }} results
                        </span>-->

          </div>
        </div>
      </div>
    </div>
    <button @click="nextSlide" :disabled="isNextDisabled"
            class="oddsmatcher-carousel-control oddsmatcher-carousel-next">❯
    </button>
  </div>
  <div v-else>
    <h3>Please fill in the options</h3>
  </div>
</template>


<style scoped>

.positive-profit {
  color: green;
}

.negative-profit {
  color: red;
}

h6 {
  font-weight: bold;
}

.oddsmatcher-matched-bet-container {
  background-color: var(--clr-primary-20);
  border: 1px solid #ddd;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  padding-block: 1rem;
  height: 450px;
}

@media (min-width: 576px) {
  .oddsmatcher-matched-bet-container {
    height: 500px;
  }
}

.oddsmatcher-matched-bet-container > * {
  margin: 0 16%;
}

.om-choice-head {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-block: 0.5rem;
}

.om-event {
  padding-top: 0;
}

.om-back {

}

.om-lay {
}

p {
  margin-bottom: 0;
  padding-bottom: 0.5rem;
}

.oddsmatcher-carousel {
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  width: 100%;
  overflow: hidden;
  margin-bottom: 4rem;
  max-width: 100vw;
}


.oddsmatcher-back-lay-container > * {
  flex-grow: 1;
}

.oddsmatcher-carousel-container {
  width: 100%;
  overflow: hidden;

}

.oddsmatcher-carousel-track {
  display: flex;
  transition: transform 0.5s ease;
}

.oddsmatcher-carousel-slide {
  min-width: 100%;
  box-sizing: border-box;
}


.oddsmatcher-carousel-control {
  background: none;
  border: none;
  font-size: 2rem;
  cursor: pointer;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
}

.oddsmatcher-carousel-prev {
  left: 10px;
  z-index: 5;
  background-color: white;
  padding: 0.25rem;
  border-radius: 4px;

}

.oddsmatcher-carousel-next {
  right: 10px;
  z-index: 5;
  background-color: white;
  padding: 0.25rem;
  border-radius: 4px;
}


</style>

